import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { _link } from "./common/utilities";

const fallbackLng = ['en'];
const availableLanguages = ['en'];

//force br use temporiarly -- good for translation dev on storybook
//comment out when building react app
// window._region = 'BR';

i18n
  .use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step

  .use(LanguageDetector) // detect user language

  .use(initReactI18next) // pass the i18n instance to react-i18next.

  .init({
    fallbackLng: fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: false,
    whitelist: availableLanguages,
    keySeparator: false,  //allows use of '.' in translations
    nsSeparator: false, //allows use of ':' in translations

    interpolation: {
      escapeValue: false
    },

    backend: {
        // path where resources get loaded from, or a function
        // returning a path:
        // function(lngs, namespaces) { return customPath; }
        // the returned path will interpolate lng, ns if provided like giving a static path
        //loadPath: _link["url_crossfire_na"] + '/locales/translation.json',
        // loadPath: 'https://crossfire.z8games.com/locales/translation.json',
        loadPath: window._region === 'BR' ? '//br.crossfire.z8games.com/locales/translation.json' : '//crossfire.z8games.com/locales/translation.json',
        //loadPath: '/locales/en/translation.json',

        // path to post missing resources
        //addPath: 'locales/add/{{lng}}/{{ns}}',

        // your backend server supports multiloading
        // /locales/resources.json?lng=de+en&ns=ns1+ns2
        // Adapter is needed to enable MultiLoading https://github.com/i18next/i18next-multiload-backend-adapter
        // Returned JSON structure in this case is
        // {
        //  lang : {
        //   namespaceA: {},
        //   namespaceB: {},
        //   ...etc
        //  }
        // }
        allowMultiLoading: false, // set loadPath: '/locales/resources.json?lng={{lng}}&ns={{ns}}' to adapt to multiLoading

        // parse data after it has been fetched
        // in example use https://www.npmjs.com/package/json5
        // here it removes the letter a from the json (bad idea)
        // parse: function(data) { return data.replace(/a/g, ''); },

        // allow cross domain requests
        crossDomain: true,

        // allow credentials on cross domain requests
        withCredentials: false,

        // overrideMimeType sets request.overrideMimeType("application/json")
        overrideMimeType: false,

        /*
        // custom request headers sets request.setRequestHeader(key, value)
        customHeaders: {
          authorization: 'foo',
          // ...
        },
        */

        /*
        // define a custom xhr function
        // can be used to support XDomainRequest in IE 8 and 9
        //
        // 'url' will be passed the value of 'loadPath'
        // 'options' will be this entire options object
        // 'callback' is a function that takes two parameters, 'data' and 'xhr'.
        //            'data' should be the key:value translation pairs for the
        //            requested language and namespace, or null in case of an error.
        //            'xhr' should be a status object, e.g. { status: 200 }
        // 'data' will be a key:value object used when saving missing translations
        ajax: function (url, options, callback, data) {},
        */

        // adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
        queryStringParams: { v: '1.0.0' }
      }
  });

export default i18n;